import isArray from 'lodash-es/isArray';
import range from 'lodash-es/range';
import React from 'react';
import { Colors } from 'module/View/Common';
import { createPureComponent } from 'module/Common';
import glam from 'glamorous';
import * as glamor from 'glamor';

type WrapperProps = {
  margin: [number, number];
};

export const Wrapper = glam.div<WrapperProps>(p => ({
  padding: 0,
  margin: `${p.margin[0]}rem 0 ${p.margin[1]}rem 0`,
  overflow: 'hidden',
}));

type PathProps = {
  animate: boolean;
  waveSize: number;
  leftPos: number;
};

const waveAnim = (p: PathProps) =>
  glamor.keyframes({
    '0%': { transform: `translateX(${p.leftPos}px)` },
    '100%': { transform: `translateX(${p.leftPos + p.waveSize}px)` },
  });

const Path = glam.path<PathProps>(p => {
  return {
    ...(!p.animate
      ? {}
      : {
          animation: `${waveAnim(p)} 1.2s infinite linear`,
        }),
  };
});

type Props = {
  width: number;
  margin?: number | [number, number];
  color?: string;
  centered?: boolean;
  overflow?: boolean;
  animate?: boolean;
};

export const Wave = createPureComponent<Props>(
  'Wave',
  ({ width, margin = 0, color = Colors.dark, centered = false, overflow = false, animate = false }) => {
    const doOverflow = overflow || animate;
    const amplitude = 6;
    const stroke = 2;
    const length = 4;
    const steps = Math.floor(width / (length * 3)) + (doOverflow ? 6 : -1);
    const waveWidth = length * 3 * steps;
    const leftPos = (centered ? Math.floor((width - waveWidth) / 2) : 0) - (doOverflow ? length * 3 * 3 : 0);
    const halfAmp = Math.floor(amplitude / 2);
    const halfStroke = Math.ceil(stroke / 2);
    const center = halfAmp + halfStroke;
    const d = [
      `M${halfStroke},${center}`,
      range(steps)
        .map(step => {
          const left = halfStroke + length + step * (length * 3);
          const controlY = center + (step % 2 === 0 ? 1 : -1) * halfAmp;
          return `C${left},${controlY} ${left + length},${controlY} ${left + length * 2},${center}`;
        })
        .join(' '),
    ].join(' ');
    const height = center * 2;

    const resolvedMargin: [number, number] = isArray(margin) ? margin : [margin, margin];
    return (
      <Wrapper margin={resolvedMargin}>
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
          <Path
            animate={animate}
            waveSize={length * 6}
            leftPos={leftPos}
            d={d}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            transform={`translate(${leftPos} 0)`}
          />
        </svg>
      </Wrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Common/component/Wave/index.tsx